import React from 'react'
import SbEditable from "storyblok-react"
import FluidImage from 'src/utils/FluidImage'
import WaveInverted from 'src/images/wave_big_inverted.svg'
import Heading from 'src/components/Heading'
import CustomBreadcrumbs from 'src/utils/CustomBreadcrumbs'

const HeroCustom = ({ blok }) => {
    return (
        <SbEditable content={blok} key={blok._uid}>
            <div className="relative overflow-hidden">
                <div className={`2xl:h-[85vh] xl:h-[90vh] h-[85vh] w-full`}>
                    <div className="absolute inset-0">
                        <FluidImage
                            className="w-full h-full object-cover"
                            image={blok.image}
                        />
                    </div>
                    <div className="max-w-7xl mx-auto relative px-6 py-16 h-full w-full flex flex-col justify-center items-start 2xl:max-w-screen-2xl">
                        {!blok.disable_breadcrumbs &&
                            <CustomBreadcrumbs className="lg:mb-12 mb-8" white/>
                        }
                        <Heading size="h1" className="text-white lg:max-w-[820px] lg:!mb-8 !mb-4 !text-5xl md:!text-6xl lg:!text-7xl xl:!text-7.5xl 2xl:!text-7.75xl">{blok.title}</Heading>
                        <p className="text-white md:text-base text-sm max-w-xl">{blok.description}</p>
                    </div>
                </div>
               {/*<WaveInverted className="w-full z-10 relative fill-white"/> */} 
            </div>
        </SbEditable>
    )
}

export default HeroCustom